import { Button } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import './EmptyFavorites.scss';

const EMPTY_FAVORITES_IMAGE =
  'https://static.spotahome.com/images/logged_favorites.svg';

const EmptyFavoritesNotLogged = () => (
  <div className="empty-favorites" id="no-results">
    <img
      className="empty-favorites__image"
      src={EMPTY_FAVORITES_IMAGE}
      alt={trans('favorites.message.continue_searching')}
    />

    <p className="empty-favorites__text">
      {trans('favorites.message.will_appear')}
    </p>
    <div className="empty-favorites__button-container">
      <Button className="ga-favorites-page-account-link" href="/">
        {trans('favorites.message.continue_searching')}
      </Button>
    </div>
  </div>
);

export default EmptyFavoritesNotLogged;
